export interface ErrorObject {
  status: number;
  title: string;
  source?: {
    parameter: string;
  };
}

export interface ErrorResponse {
  errors?: ErrorObject[];
  [key: string]: any;
}

export function generateErrorMessage(
  errors: ErrorObject[] | undefined,
  fallback: string
): string {
  if (errors && errors.length > 0) {
    return errors.map((error) => error.title).join(", ");
  } else {
    return fallback;
  }
}
